import React, { useState } from 'react';
import { Image, Linking, Modal } from "react-native"
import { Button, Text, View } from './Themed';
import Checkbox from './Checkbox';
import { useColors } from '../constants/useColors';


type ConfirmationModalProps = {
    visible:boolean,
    title?:string,
    mode: 'desktop'|'mobile',
    description?:string,
    confirm_title?:string,
    padding_bottom?:number,
    opt_in_url?:string,
    cancel_title?:string,
    image?:string,
    onCancel?: () => void,
    onConfirm: () => void
}
const ConfirmationModal = ({ visible, mode, title, opt_in_url, padding_bottom, image, description, confirm_title, cancel_title, onCancel, onConfirm }:ConfirmationModalProps) => {
    const [ opted_in, setOptedIn ] = useState(true);
    const Colors = useColors();
    return (
        <Modal 
            visible={visible}
            animationType={mode=='desktop' ? 'fade' : 'slide'}
            transparent
            style={{ flex:1 }}>
            <View type='blur' style={mode=='desktop' ?{ flex:1, justifyContent:'center', alignItems:'center' }:{ flex:1, justifyContent:'flex-end', paddingBottom:padding_bottom }}>
                <View float style={mode=='desktop'?{width:500, borderRadius:22}:{ borderTopRightRadius:22, borderTopLeftRadius:22  }}>
                    <View type='header' style={{ padding:20, borderTopRightRadius:22, borderTopLeftRadius:22 }}>
                        <Text theme='h1'>{title ?? 'Are you sure?'}</Text>
                    </View>
                    <View transparent style={{ minHeight:100, padding:20 }}>
                        {image?
                        <Image
                            source={{ uri: image }}
                            style={{ width:200, height:200 , marginBottom: 10, alignSelf:'center'}}
                            resizeMode='cover'
                        />
                        :<></>}
                        <Text size={14} theme='h2' textAlign='center' weight='semibold'>{description}</Text>
                    </View>
                    {opt_in_url?
                    <View style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                        <Checkbox
                            checked={opted_in}
                            color={Colors.text.action}
                            onSelect={() => setOptedIn(!opted_in)}
                        />
                        <Button type='text' style={{ flex:1, marginLeft:5 }} onPress={() => Linking.openURL(opt_in_url)}>
                            <Text theme='description' color={Colors.text.action}>By confirming you are agreeing to the terms and conditions outlined here HERE</Text>
                        </Button>
                    </View>
                    :<></>}
                    <View type='footer' style={{ padding:10, flexDirection:'row' }}>
                        {onCancel?
                        <Button
                            title={cancel_title ?? 'CANCEL'}
                            style={{ flex:1 }}
                            type='error'
                            onPress={() => onCancel()}
                        />
                        :<></>}
                        <Button
                            title={confirm_title ?? 'CONFIRM'}
                            style={{ flex:1, marginLeft:5, opacity:!opted_in && opt_in_url ? 0.5: 1 }}
                            disabled={opt_in_url && !opted_in ? true : false}
                            type='success'
                            onPress={() => onConfirm()}
                        />
                    </View>
                </View>
            </View>
        </Modal>
    )
}

export default ConfirmationModal